export class ROUTEDATA {
    ID = 0;
    VQuad_Timestamp: Date;
    Start_Timestamp: Date;
    Call_Timestamp: Date;
    VQuad_Location: string;
    VQuad_PhoneID: string;
    GPS_Position: string;
    GPS_Lat = 0;
    GPS_Long = 0;
    Start_GPS_Position: string;
    Start_GPS_Lat = 0;
    Start_GPS_Long = 0;
    Net_Speed_Test: string;
    Battery_Level: number;
    RSSI: number;
    Network_Type: string;
    TN_Number: string;

    Target_Server: string;
    TestStatus: string;
    Hops = 0;
    Response_to_End = 0;
    Max_Response = 0;
    Loss_to_End = 0;
    Max_Loss = 0;
    DNS_Time = 0;
    Trace_to_IP: string;
    Trace_from_IP: string;

    CallType_Orig: string;
    CallType_Term: string;
    VQuad_CallID: string;

    constructor() {
    this.ID = 0;
    this.VQuad_Timestamp = new Date();
    this.Start_Timestamp = new Date();
    this.Call_Timestamp = new Date();
    this.VQuad_Location = "";
    this.VQuad_PhoneID = "";
    this.GPS_Position = "";
    this.GPS_Lat = 0;
    this.GPS_Long = 0;
    this.Start_GPS_Position = "";
    this.Start_GPS_Lat = 0;
    this.Start_GPS_Long = 0;
    this.Net_Speed_Test = "";
    this.Battery_Level = 0;
    this.RSSI = 0;
    this.Network_Type = "";
    this.TN_Number = "";
    
    this.Target_Server = "";
    this.TestStatus = "";
    this.Hops = 0;
    this.Response_to_End = 0;
    this.Max_Response = 0;
    this.Loss_to_End = 0;
    this.Max_Loss = 0;
    this.DNS_Time = 0;
    this.Trace_to_IP = "";
    this.Trace_from_IP = "";
    
    this.CallType_Orig = "";
    this.CallType_Term = "";
    this.VQuad_CallID = "";
 
    }  
  
}
